var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1292_11321)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 0.5C7.78289 0.5 4.26562 3.89703 4.26562 8.23438C4.26562 9.88447 4.76147 11.3559 5.71308 12.7347L11.4081 21.6212C11.6844 22.0532 12.3162 22.0524 12.5919 21.6212L18.3116 12.7044C19.2428 11.3881 19.7344 9.84252 19.7344 8.23438C19.7344 3.96964 16.2647 0.5 12 0.5ZM12 11.75C10.0616 11.75 8.48438 10.1728 8.48438 8.23438C8.48438 6.29595 10.0616 4.71875 12 4.71875C13.9384 4.71875 15.5156 6.29595 15.5156 8.23438C15.5156 10.1728 13.9384 11.75 12 11.75Z",
    fill: "#303030"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4967 16.6582L13.9562 22.1935C13.0398 23.6224 10.9551 23.6177 10.0431 22.1949L6.49678 16.6597C3.37659 17.3811 1.45312 18.7026 1.45312 20.2819C1.45312 23.0223 6.88725 24.5006 12 24.5006C17.1128 24.5006 22.5469 23.0223 22.5469 20.2819C22.5469 18.7015 20.6207 17.3792 17.4967 16.6582Z",
    fill: "#303030"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1292_11321"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.2acef165c959c0f8f79c146a610050a8.svg";
export { ForwardRef as ReactComponent };